import { render, staticRenderFns } from "./MatchAnalysis.vue?vue&type=template&id=84a71f52&scoped=true&"
import script from "./MatchAnalysis.vue?vue&type=script&lang=js&"
export * from "./MatchAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./MatchAnalysis.vue?vue&type=style&index=0&id=84a71f52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84a71f52",
  null
  
)

export default component.exports